/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React, { useContext } from 'react';
import { Typography } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import DeviceOperationsContainer from '../../../../components/DeviceOperations';
import styles from './styles.module.css';
import { DeviceDetailsContext } from '../../index';
import { useTranslation } from 'react-i18next';

const { Title } = Typography;

const DeviceOperations = () => {
  const deviceDetails = useContext(DeviceDetailsContext);
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <Title level={4} className={styles.title}>
        <CheckCircleOutlined /> {t('label_DeviceOperations')}
      </Title>
      <DeviceOperationsContainer
        ownerships={[deviceDetails.device.enrolmentInfo.ownership]}
        deviceType={deviceDetails.device.type}
        deviceIdentifiers={[deviceDetails.deviceIdentifier]}
        deviceStatus={deviceDetails.device.enrolmentInfo.status}
        idType={'device'}
      />
    </div>
  );
};

export default DeviceOperations;
